import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import BetaLogo from './beta'

type LogoProps = {
    inverted?: boolean
    isBeta?: boolean
}

const Logo: React.FunctionComponent<LogoProps> = ({ inverted, isBeta }) => (
    <CustomLink to='/' >
        <Container isBeta={isBeta || false}>
            <Icon inverted={inverted}>
                <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22 29.6546C22.3164 26.4919 24.3721 20.262 30.0647 20.6415C32.2362 20.7862 33.9659 21.0635 35.4291 21.2981C38.7608 21.8322 40.7107 22.1448 43.3477 20.1671V20.1677C43.3476 21.5906 43.3475 22.5394 42.3989 24.4366C43.8222 22.5391 44.2965 20.6415 43.8221 18.744C41.9245 20.6415 40.027 21.1159 37.655 20.6415C38.1294 19.3765 38.6038 16.8464 38.1295 15.4231C36.7062 16.8464 36.2318 17.3208 35.2831 17.7951C35.7574 16.8464 35.7574 14.9488 35.2831 14C33.8598 16.8464 32.911 17.7951 28.6416 18.2695C22.9579 18.9011 22.0045 23.9385 22 26.3175C21.9955 23.9384 21.042 18.9012 15.3584 18.2697C11.0889 17.7953 10.1402 16.8465 8.71691 14.0002C8.24259 14.949 8.24259 16.8465 8.71691 17.7952C7.7682 17.3209 7.29381 16.8465 5.87055 15.4233C5.39623 16.8465 5.87063 19.3766 6.34502 20.6417C3.97305 21.1161 2.07548 20.6417 0.177919 18.7441C-0.29649 20.6417 0.177814 22.5393 1.60109 24.4368C0.652462 22.5396 0.6524 21.5908 0.652307 20.1679V20.1672C3.28931 22.145 5.23921 21.8324 8.57085 21.2983C10.0341 21.0637 11.7638 20.7864 13.9353 20.6416C19.6279 20.2621 21.6836 26.4921 22 29.6548V29.655C22 29.6549 22 29.655 22 29.655C22 29.655 22 29.655 22 29.6551V29.6546Z" fill="#625ED8"/>
                </svg>
            </Icon>
            {/* { isBeta && <BetaLogo /> } */}
        </Container>
    </CustomLink>
)

const CustomLink = styled(Link)`
    &, &:visited, &:active {
        text-decoration: none;
    }
`

const Container = styled.div<{ isBeta: boolean }>`
    display: grid;
    align-items: center;
    grid-template-columns: ${p => p.isBeta ? 'repeat(1, auto)' : 'auto' };
    grid-column-gap: 12px;
`

const Icon = styled.div<{ inverted?: boolean }>`
    width: 44px;
    height: 44px;

    & path {
        fill: ${p => p.inverted ? p.theme.colors.accent : p.theme.colors.bg};
    }
`


export default Logo